import request from '@/http'
const url = process.env.VUE_APP_BUILD
export const BuildingPower = {

  PowerCategory: () => request.get(`${url}/api/font/category`), // 获取工队类目
  getPages: (params) => request.post(`${url}/api/font/pages`, params), // 首页企业筛选
  getCompleteAreas: (params) => request.get(`${url}/api/font/complete/area`, params),
  getQtList: (params) => request.get(`${url}/api/font/qtlist`, params), // 根据企业类型查询资质类型列表
  getQlList: (params) => request.get(`${url}/api/font/qllist`, params), // 根据资质类型查询资质等级列表
  getReList: (params) => request.get(`${url}/api/font/relist`, params), // 根据区划获取备案单位列表
  getCompanyDetail: (params) => request.get(`${url}/api/font/detail`, params), // 获取企业详情
  getZzList: (params) => request.get(`${url}/api/font/zzlist`, params), // 获取资质项
  getGcyjPages: (params) => request.get(`${url}/api/font/gcyjpages`, params), // 获取企业工程业绩
  getBarcPages: (params) => request.get(`${url}/api/font/barcpages`, params), // 获取企业备案人才
  getRemarks: (params) => request.get(`${url}/api/font/remarks`, params) // 获取属性和属性值集合
  //   fetchRecommendedTalent: () => request.get('/api/index/getRecommendTalent'), // 获取推荐人才
  //   fetchRecommendTeam: () => request.get('/api/index/getRecommendTeam'), // 获取推荐工队
  //   getHotJobs: () => request.get('/api/index/getHotTalentRecruit'), // 获取热门职位
  //   getTheRecruitmentTeam: () => request.get('/api/teamRecruit/getNewList'), // 获取招工
  //   fetchRecommendCompany: () => request.get('/api/index/getRecommendCompany'), // 获取推荐企业
  //   getMenuList: () => request.get(process.env.VUE_APP_MENUURL), // 获取菜单
  //   getHotKey: () => request.get('/search/getHotkeys')

}
